<template>
    <div>
        <!-- 回访完成 -->
        <el-form :rules="rules" ref="form" :model="form" label-width="100px">
            <!--<el-form-item label="处理意见">-->
                <!--<el-input type="textarea" v-model="form.handleComment"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.handleComment"></el-input>

            </el-form-item>
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    import notifyTab from "../common/notifyTab.vue"
    export default {
        props:{
            serialNumber:String,
            title:String,
            callback:Function,
        },
        components:{notifyTab},
        data() {
            return {
                rules:{},
                form:{
                    handleComment:"",
                    notify:[]
                },
                notifyUserid:[],
                isSubmit:false
            }
        },
        created() {
            this.$modal.title = this.title;
        },
        methods: {
            remarkFn(val){
                this.form.handleComment = val;
            },
            submit(){
                this.isSubmit=true
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let params = {
                    ...this.form,
                    handle:this.title,
                    serialNumber:this.serialNumber,
                    notify:this.notifyUserid
                }
                services.eventHandle(params).then(res => {
                    this.$message.success(this.title+"成功");
                    this.callback();
                    this.$modal.close();
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
